{
  "newCampaign": "Neue Kampagne",
  "firmware": {
    "update": {
      "label": "Firmware aktualisieren",
      "description": "Datum- und Zeitparameter sind erforderlich, um das Update der Firmware {name} zu starten",
      "firmwareLabel": "Firmware",
      "uuidRequired": "Die Firmware ist erforderlich",
      "plannedStartAt": "Datum und Uhrzeit der Firmware-Aktualisierung (YYYY/MM/DD HH:MM)",
      "notaBene": "Die Aktualisierung der Firmware wird während der nächsten Kommunikation mit dem {name} ab dem Datum und der Uhrzeit der Firmware-Aktualisierung durchgeführt.",
      "dateTimeError": "Für die Aktualisierung der Firmware sind Datum und Uhrzeit erforderlich",
      "firmwareSelection": "Eine Firmware aus der Liste unten auswählen",
      "FirmwareSelectionRequired": "Sie müssen eine Firmware aus der Liste auswählen",
      "warningMessage": "Warnung: Die Aktualisierung der Firmware führt am Ende des Updates zum Neustart der zugehörigen Geräte."
    }
  },
  "dateInferiorToToday": "Das Datum darf nicht früher als das heutige Datum/die jetzige Uhrzeit sein",
  "dateInferiorToDate": "Das Datum darf nicht kleiner sein als {date}",
  "dateFormat": "YYYY-MM-DD HH:mm",
  "confirm": "Bestätigen",
  "cancel": "Abbrechen",
  "list": {
    "column": {
      "name": {
        "label": "Kampagne"
      },
      "type": {
        "label": "Typ",
        "CRTCLT_RENEWAL_DVC": "Verlängerung von Gerätezertifikaten",
        "CRTCLT_RENEWAL_APP": "Verlängerung von Anwendungszertifikaten",
        "FIRMWARE_UPGRADE_DVC": "Geräte-Firmware-Aktualisierung"
      },
      "dates": {
        "label": "Daten",
        "format": "YYYY-MM-DD"
      },
      "numberOfEquipments": {
        "label": "Anzahl der Geräte",
        "value": "{count} Geräte | {count} Gerät | {count} Geräte"
      },
      "status": {
        "label": "Status",
        "value": {
          "SCHEDULED": "Geplant",
          "RUNNING": "Wird ausgeführt",
          "PAUSED": "Pausiert",
          "COMPLETE": "Abgeschlossen",
          "COMPLETE_WITH_ERRORS": "Mit Fehlern abgeschlossen",
          "INCOMPLETE": "Unvollständig",
          "PLATFORM_ERROR": "Fehler",
          "CANCELLING": "Wird abgebrochen",
          "CANCELLED": "Abgebrochen",
          "UNKNOWN": "Unbekannt",
          "DRAFT": "Entwurf"
        }
      },
      "pending": {
        "label": "Ausstehend"
      },
      "inProgress": {
        "label": "In Bearbeitung"
      },
      "success": {
        "label": "Erfolg"
      },
      "failed": {
        "label": "Fehlgeschlagen"
      },
      "numberOfDevice": {
        "label": "Anzahl der Geräte",
        "value": "{count} Geräte | {count} Gerät | {count} Geräte"
      },
      "operations": "Betrieb",
      "done": {
        "label": "Fertig"
      }
    },
    "empty": "Keine Kampagnen gefunden"
  },
  "details": {
    "buttons": {
      "update": {
        "label": "Aktualisieren"
      },
      "cancel": {
        "label": "Die Kampagne abbrechen",
        "confirm": {
          "message": "Soll die Kampagne wirklich abgebrochen werden?",
          "title": "Kampagne abbrechen",
          "yes": "Ja",
          "no": "Nein"
        }
      },
      "edit": {
        "label": "Bearbeiten"
      }
    },
    "properties": {
      "title": "Eigenschaften",
      "name": {
        "label": "Name"
      },
      "type": {
        "label": "Typ",
        "CRTCLT_RENEWAL_DVC": "Verlängerung von Gerätezertifikaten",
        "CRTCLT_RENEWAL_APP": "Verlängerung von Anwendungszertifikaten",
        "FIRMWARE_UPGRADE_DVC": "Geräte-Firmware-Aktualisierung"
      },
      "dates": {
        "label": "Daten"
      },
      "state": {
        "label": "Status"
      }
    },
    "characteristics": {
      "title": "Eigenschaften",
      "createdBy": "Erstellt von",
      "type": {
        "label": "Typ: ",
        "value": {
          "CRTCLT_RENEWAL_DVC": "Verlängerung von Gerätezertifikaten",
          "CRTCLT_RENEWAL_APP": "Verlängerung von Anwendungszertifikaten",
          "FIRMWARE_UPGRADE_DVC": "Geräte-Firmware-Aktualisierung"
        }
      },
      "status": {
        "label": "Status:",
        "value": {
          "SCHEDULED": "Geplant",
          "RUNNING": "Wird ausgeführt",
          "PAUSED": "Pausiert",
          "COMPLETE": "Abgeschlossen",
          "COMPLETE_WITH_ERRORS": "Fehlgeschlagen",
          "INCOMPLETE": "Fehlgeschlagen",
          "PLATFORM_ERROR": "Fehler",
          "CANCELLING": "Wird abgebrochen",
          "CANCELLED": "Abgebrochen"
        }
      },
      "lifeCyle": {
        "creation": "Erstellung: {value}",
        "launch": "Start: {value}",
        "closing": "Abschluss: {value}"
      },
      "inclusionPeriods": {
        "title": "Einbezugszeiträume",
        "inactive": "Inaktiv",
        "monday": "Montag: {value}",
        "tuesday": "Dienstag: {value}",
        "wednesday": "Mittwoch: {value}",
        "thursday": "Donnerstag: {value}",
        "friday": "Freitag: {value}",
        "saturday": "Samstag: {value}",
        "sunday": "Sonntag: {value}"
      },
      "equipments": {
        "title": "{count} Geräte | {count} Gerät | {count} Geräte",
        "status": {
          "pending": "Ausstehend: {percent}, {count} Geräte | Ausstehend: {percent}, {count} Gerät | Ausstehend: {percent}, {count} Geräte",
          "running": "Werden ausgeführt: {percent}, {count} Geräte | Wird ausgeführt: {percent}, {count} Gerät | Werden ausgeführt: {percent}, {count} Geräte",
          "complete": "Abgeschlossen: {percent}, {count} Geräte | Abgeschlossen: {percent}, {count} Gerät | Abgeschlossen: {percent}, {count} Geräte",
          "failed": "Fehlgeschlagen: {percent}, {count} Geräte | Fehlgeschlagen: {percent}, {count} Gerät | Fehlgeschlagen: {percent}, {count} Geräte"
        },
        "statistics": {
          "title": "{count} Geräte | {count} Gerät | {count} Geräte"
        }
      },
      "devices": {
        "status": {
          "scheduled": "Geplant: {percent}, {count} Geräte | Geplant: {percent}, {count} Gerät | Geplant: {percent}, {count} Geräte",
          "completed": "Abgeschlossen: {percent}, {count} Geräte | Abgeschlossen: {percent}, {count} Gerät | Abgeschlossen: {percent}, {count} Geräte",
          "error": "Fehler: {percent}, {count} Geräte | Fehler: {percent}, {count} Gerät | Fehler: {percent}, {count} Geräte",
          "running": "Betrieb: {percent}, {count} Geräte | Betrieb: {percent}, {count} Gerät | Betrieb: {percent}, {count} Geräte"
        }
      },
      "operationType": "Typ: "
    },
    "equipments": {
      "title": "Geräteliste",
      "column": {
        "label": {
          "label": "Gerätename"
        },
        "deviceType": {
          "label": "Gerätetyp"
        },
        "message": {
          "label": "Betriebszustand"
        },
        "startDate": {
          "label": "Betriebsstartdatum",
          "format": "YYYY-MM-DD HH:mm"
        },
        "lastOperationDate": {
          "label": "Datum des letzten Vorgangs",
          "format": "YYYY-MM-DD HH:mm"
        },
        "name": {
          "label": "Name"
        },
        "serialNumber": {
          "label": "Seriennummer"
        },
        "firmware": {
          "label": "Firmware"
        },
        "connectivity": {
          "label": "Konnektivität"
        },
        "metastatus": {
          "label": "Metastatus"
        },
        "sector": {
          "label": "Sektor"
        },
        "lastUpdate": {
          "label": "Datum der letzten Aktualisierung"
        },
        "operationStatus": {
          "label": "Betriebsstatus"
        }
      },
      "empty": "Keine Geräte gefunden",
      "states": {
        "WITHDRAWN": "Zurückgezogen",
        "DEACTIVATED": "Deaktiviert",
        "DELETED": "Gelöscht"
      }
    },
    "status": {
      "title": "Kampagnenstatus"
    },
    "cancel": {
      "error": "Beim Abbrechen der Kampagne ist ein Fehler aufgetreten.",
      "success": "Der Kampagnenabbruch wurde erfolgreich ausgelöst."
    }
  },
  "form": {
    "campaignSettings": {
      "title": "Kampagneneinstellungen",
      "name": "Kampagnenname",
      "typeOfCampaign": {
        "title": "Kampagnentyp",
        "firmwareUpdate": {
          "title": "Firmware-Aktualisierungskampagne",
          "option": "Geräte-Firmware-Aktualisierung",
          "label": "Firmware-Name",
          "dependencies": "Abhängigkeiten"
        },
        "deviceCertificateRenewal": "Verlängerung von Gerätezertifikaten",
        "applicationCertificateRenewal": "Verlängerung von Anwendungszertifikaten"
      },
      "validation": {
        "name": "Der Kampagnenname ist erforderlich",
        "type": "Der Kampagnentyp ist erforderlich",
        "firmwareUuid": "Die Firmware ist erforderlich"
      }
    },
    "fleetSelection": {
      "title": "Auswahl der Geräteflotte",
      "devices": "Geräte",
      "applications": "Anwendungen",
      "validation": {
        "required": "Die Auswahl von mindestens einem Gerät ist erforderlich"
      },
      "actions": {
        "scheduled": {
          "confirm": {
            "title": "Bestehende geplante Aktionen",
            "message": "Einige ausgewählte Geräte haben bereits geplante Aktionen. Fortfahren?",
            "yes": "Ja",
            "no": "Nein"
          }
        }
      }
    },
    "campaignPlanification": {
      "title": "Kampagnenplanung",
      "executionDates": {
        "title": "Kampagnendurchführungsdaten",
        "plannedStartAt": "Kampagnenstartdatum",
        "endDate": "Kampagnenenddatum",
        "validation": {
          "plannedStartAt": "Das Kampagnenstartdatum ist erforderlich",
          "plannedEndAt": "Das Kampagnenenddatum ist erforderlich",
          "startDateNotBeyondLicenseExpirationDateTolerancy": "Das Kampagnenstartdatum darf nicht nach dem Toleranzdatum für das Ablaufdatum der Lizenz liegen",
          "endDateNotBeyondLicenseExpirationDateTolerancy": "Das Kampagnenenddatum darf nicht nach dem Toleranzdatum für das Ablaufdatum der Lizenz liegen"
        }
      },
      "inclusionPeriods": {
        "title": "Einbezugszeiträume",
        "remove": "Entfernen",
        "add": "Hinzufügen",
        "day": "Tag",
        "days": {
          "monday": "Montag",
          "tuesday": "Dienstag",
          "wednesday": "Mittwoch",
          "thursday": "Donnerstag",
          "friday": "Freitag",
          "saturday": "Samstag",
          "sunday": "Sonntag"
        },
        "validation": {
          "day": "Der Tag des Einbezugszeitraums ist erforderlich",
          "range": "Die Dauer eines Slots im Einbezugszeitraum darf nicht weniger als 15 Minuten betragen"
        }
      }
    },
    "buttons": {
      "next": "Weiter",
      "previous": "Zurück",
      "submit": "Senden"
    }
  },
  "report": {
    "title": "Bericht",
    "plannedStartAt": "Kampagnenstartdatum:",
    "processes": {
      "column": {
        "label": "Name",
        "status": "Status"
      }
    }
  },
  "funnel": {
    "step": "Schritt",
    "of": "von",
    "newCampaign": "Eine neue Kampagne einrichten",
    "updateCampaign": "Die Kampagne aktualisieren",
    "scheduling": "Terminplanung",
    "next": "Weiter",
    "previous": "Zurück",
    "publish": "Die Kampagne veröffentlichen",
    "campaignSettings": {
      "title": "Die Einstellungen wählen",
      "name": "Kampagnenname",
      "typeOfCampaign": {
        "title": "Kampagnentyp",
        "firmwareUpdate": {
          "label": "Firmware-Aktualisierung",
          "title": "Firmware-Aktualisierungskampagne",
          "firmwareName": "Firmware-Name"
        },
        "certificate": "Zertifikat",
        "deviceCertificateRenewal": "Verlängerung von Gerätezertifikaten",
        "applicationCertificateRenewal": "Verlängerung von Anwendungszertifikaten",
        "configurationUpdate": {
          "selfSupporting": {
            "warningMessage": "Diese Kampagne wendet die zuletzt hochgeladene Parametrierung auf jedes Ihrer ausgewählten Geräte an."
          }
        }
      },
      "validation": {
        "name": "Der Kampagnenname ist erforderlich",
        "type": "Der Kampagnentyp ist erforderlich",
        "firmwareUuid": "Die Firmware ist erforderlich"
      },
      "operationModelType": {
        "CONFIG": "Parametrierung",
        "FIRM_UPDATE": "Firmware-Aktualisierung",
        "OPTIONS": "Optionen",
        "CERT_RENEW": "Zertifikatverlängerung"
      }
    },
    "fleetSelection": {
      "title": "Geräteflotte",
      "validation": {
        "required": "Die Auswahl von mindestens einem Gerät ist erforderlich"
      },
      "actions": {
        "scheduled": {
          "confirm": {
            "title": "Bestehende geplante Aktionen",
            "message": "Einige ausgewählte Geräte haben bereits geplante Aktionen. Fortfahren?",
            "yes": "Ja",
            "no": "Nein"
          }
        }
      },
      "devices": "Geräte",
      "fleets": "Flotten",
      "fleetInformation": {
        "title": "Informationen zu {fleetName}",
        "message": {
          "beginning": "Mit der aktuellen Kampagnenparametrierung kann/können",
          "middle": "{count} Gerät in der Flotte | {count} Gerät in der Flotte | {count} Geräte in der Flotte",
          "end": "nicht aktualisiert werden"
        }
      }
    },
    "campaignPlanification": {
      "title": "Das Datum wählen",
      "executionDates": {
        "plannedStartAt": "Kampagnenstartdatum",
        "endDate": "Kampagnenenddatum",
        "validation": {
          "plannedStartAt": "Das Kampagnenstartdatum ist erforderlich",
          "startDateNotBeyondLicenseExpirationDateTolerancy": "Das Kampagnenstartdatum darf nicht nach dem Toleranzdatum für das Ablaufdatum der Lizenz liegen",
          "endDateNotBeyondLicenseExpirationDateTolerancy": "Das Kampagnenenddatum darf nicht nach dem Toleranzdatum für das Ablaufdatum der Lizenz liegen",
          "plannedEndAt": "Das Kampagnenenddatum ist erforderlich"
        }
      },
      "inclusionPeriods": {
        "title": "Einschlusszeitraum",
        "subTitle": "Optional",
        "informations": {
          "period": "Dies ist eine Zeitspanne, in der das Gerät die Aktion ausführen darf.",
          "defaultValue": "Standardmäßig wird für das Gerät keine Einschränkung angewendet.",
          "businessHour": "Geschäftszeiten (Montag bis Freitag - 9:00 bis 18:00 Uhr)",
          "weekendHour": "Wochenende (Samstag bis Sonntag - 00:00 bis 23:59 Uhr)"
        },
        "days": {
          "monday": "Montag",
          "tuesday": "Dienstag",
          "wednesday": "Mittwoch",
          "thursday": "Donnerstag",
          "friday": "Freitag",
          "saturday": "Samstag",
          "sunday": "Sonntag"
        },
        "addADay": "Einen Tag hinzufügen",
        "add": "Hinzufügen",
        "delete": "Löschen",
        "selectPlaceholder": "Einen Tag auswählen",
        "start": "Start",
        "end": "Ende",
        "validation": {
          "day": "Der Tag des Einbezugszeitraums ist erforderlich",
          "start": "Der Start des Einbezugszeitraums ist erforderlich",
          "end": "Das Ende des Einbezugszeitraums ist erforderlich",
          "range": "Die Dauer eines Slots im Einbezugszeitraum darf nicht weniger als 15 Minuten betragen",
          "startAfterEnd": "Startzeit darf nicht nach Endzeit liegen",
          "endBeforeStart": "Endzeit darf nicht vor Startzeit liegen"
        },
        "presets": {
          "businessHours": "Geschäftszeiten (Montag bis Freitag - 9:00 bis 18:00 Uhr)",
          "weekend": "Wochenende (Samstag bis Sonntag - 00:00 bis 23:59 Uhr)"
        }
      }
    },
    "deviceFleetSelection": {
      "title": "Geräteflotte"
    }
  },
  "operationModelType": {
    "composite": "Verbund"
  },
  "operationMgr": {
    "filters": {
      "status": "Status",
      "type": "Typ"
    }
  }
}
